module.exports = __webpack_public_path__ + "static/bg-5af34aa73decf18d97c82991240e7f8e.png";